import { packageIdentity, templateProductIdentity, } from "./googleTagManagerItemIdentity";
export default function convertOrderLineToGoogleTagManagerItem(line) {
    if (line.type !== 0) {
        return null;
    }
    if (!line.uuid) {
        return null;
    }
    const item = Object.assign(Object.assign({}, getIdentity(line)), { price: (line.actualLinePrice / line.quantity).toFixed(2), discount: getDiscount(line), quantity: line === null || line === void 0 ? void 0 : line.quantity });
    if ("package" in line) {
        item["item_name_in_package"] = line.package.packageItems
            .map((packageItem) => {
            var _a;
            return (_a = packageItem.product) === null || _a === void 0 ? void 0 : _a.name;
        })
            .join(";");
    }
    return item;
}
function getIdentity(line) {
    var _a;
    if ("package" in line) {
        return Object.assign(Object.assign({}, packageIdentity(line.package)), getPackageVariantInfo(line.package.packageItems));
    }
    else if ("template" in line) {
        return templateProductIdentity(line.product, line.template);
    }
    return {
        item_id: line.product.uuid,
        item_name: (_a = line.product) === null || _a === void 0 ? void 0 : _a.name,
        item_category: getItemCategory(line),
    };
}
function getItemCategory(line) {
    if ("catalogue" in line) {
        return "CATALOGUE";
    }
    else if ("digitalFiles" in line) {
        return "DIGITAL_PRODUCT";
    }
    else {
        return "OTHER_PRODUCT";
    }
}
function getDiscount(line) {
    return "0.00";
    /* Discount should only be used for rebate code, which is not currently
     supported
    if (line.rebate && line.rebate.linePrice) {
      return Math.abs(line.rebate.linePrice).toFixed(2);
    } else {
      return "0.00";
    }*/
}
function getPackageVariantInfo(packageItems) {
    return {
        item_variant: packageItems
            .map((packageItem) => getPackageItemVariant(packageItem))
            .join(";"),
        item_variant_id: packageItems
            .map((packageItem) => getPackageItemVariantId(packageItem))
            .join(";"),
    };
}
function getPackageItemVariant(packageItem) {
    if (packageItem.type === "TEMPLATE_PRODUCT") {
        return packageItem.template.name;
    }
    if (packageItem.type === "CATALOGUE") {
        return packageItem.catalogue.name;
    }
    if (packageItem.type === "DIGITAL_SET" ||
        packageItem.type === "DIGITAL_FILE") {
        return `${packageItem.subject.group}: ${packageItem.subject.name}`;
    }
    return "none";
}
function getPackageItemVariantId(packageItem) {
    if (packageItem.type === "TEMPLATE_PRODUCT") {
        return packageItem.template.uuid;
    }
    if (packageItem.type === "CATALOGUE") {
        return packageItem.catalogue.uuid;
    }
    if (packageItem.type === "DIGITAL_SET" ||
        packageItem.type === "DIGITAL_FILE") {
        return packageItem.files.map((file) => file.uuid).join(",");
    }
    return "none";
}
